import { ReportProvider } from 'contexts/ReportContext';
import ReportLayout from 'layouts/ReportLayout';

interface ReportRouteProps {
  Component: React.ComponentType;
}

const ReportRoute: React.FC<ReportRouteProps> = ({ Component }) => {
  return (
    <ReportProvider>
      <ReportLayout>
        <Component />
      </ReportLayout>
    </ReportProvider>
  );
};

export default ReportRoute;